import { IActivity } from "Dashboard/scenes/Partners/domain";
import { useEffect, useState } from "react";
import { partnersService } from "../../../services/partner.service";

export function useActivities() {
  const [activities, setActivities] = useState<IActivity[]>([]);

  useEffect(() => {
    async function getData() {
      const activities = await partnersService.getAllActivities();
      setActivities(activities);
    }

    try {
      getData();
    } catch (err) {
      console.log(err);
    }
  }, []);

  return activities;
}
